import React, { useEffect, useState } from "react";
import { Wallet, ShoppingBag, Gift, TrendingUp } from "lucide-react";
import api from "../../../lib/api";
import { Label, StatCard } from "../../../components/common";

export default function PlatformFinance() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/platform/finance").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <div className="text-slate-400">Loading…</div>;
  return (
    <div className="space-y-6">
      <div><Label>Platform</Label><h1 className="font-head text-2xl font-bold text-slate-900 sm:text-3xl">Finance</h1></div>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard label="MRR" value={`R${d.mrr.toLocaleString()}`} accent="#10B981" testId="fin-mrr"><Wallet className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="ARR" value={`R${d.arr.toLocaleString()}`} accent="#4338CA" testId="fin-arr"><TrendingUp className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="Merchandise Revenue" value={`R${d.merch_revenue.toLocaleString()}`} sub={`${d.merch_order_count} orders`} testId="fin-merch"><ShoppingBag className="h-5 w-5 text-slate-300" /></StatCard>
        <StatCard label="Reward Payouts" value={`R${d.reward_payouts.toLocaleString()}`} sub={`R${d.reward_pending.toLocaleString()} pending`} accent="#F59E0B" testId="fin-payouts"><Gift className="h-5 w-5 text-slate-300" /></StatCard>
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <Label>Revenue summary</Label>
          <div className="mt-3 space-y-2 text-sm">
            <Row label="Subscription MRR" value={`R${d.mrr.toLocaleString()}`} />
            <Row label="Subscription ARR" value={`R${d.arr.toLocaleString()}`} />
            <Row label="Merchandise revenue" value={`R${d.merch_revenue.toLocaleString()}`} />
            <div className="my-2 h-px bg-slate-100" />
            <Row label="Reward payouts (allocated/claimed)" value={`R${d.reward_payouts.toLocaleString()}`} />
            <Row label="Reward pending (eligible/approved)" value={`R${d.reward_pending.toLocaleString()}`} />
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-5">
          <Label>Plan distribution</Label>
          <div className="mt-3 space-y-2">
            {d.plan_distribution.map((p) => (
              <div key={p.plan} className="flex items-center justify-between rounded-lg bg-slate-50 p-3 text-sm">
                <span className="font-medium text-slate-700">{p.plan}</span>
                <span className="sv-metric font-bold text-slate-800">{p.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return <div className="flex justify-between"><span className="text-slate-500">{label}</span><span className="sv-metric font-bold text-slate-800">{value}</span></div>;
}
